import React, { useEffect, useState } from 'react';
import './index.scss';
import Parameters from 'shared/parameters';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    EyeFilled,
    EditFilled,
    LockFilled,
    UnlockFilled,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import arrowLeft from '../../../src/img/arrow-left.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import lockOpen from '../../../src/img/lock-open.png';
import viewIcon from '../../../src/img/view-icon.png';
import editIcon from '../../../src/img/edit-icon.png';
import plusIcon from '../../../src/img/plus.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';
// import deFlag from '../../../src/img/de-icon.png';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
export default function BadgesPage(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [deletingItem, setDeletingItem] = useState(false);
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setLang] = useState('' as any);
    // const [searchInput, setSearchInput] = useState('');
    // const [filteredResults, setFilteredResults] = useState([] as any[]);
    // const searchItems = (searchValue:any) => {
    //     console.log(searchValue)
    //     setSearchInput(searchValue)
    //     if (searchValue !== '') {
    //         const filteredData = items.filter((item) => {
    //             return Object.values(item.title).join('').toLowerCase().includes(searchValue.toLowerCase())
    //         })
    //          console.log(filteredData)
    //          setFilteredResults(filteredData)
    //     }
    //     else{
    //          setFilteredResults(items)
    //     }
    // }
    const columns = [
        {
            title: t('genDict.title'),
            key: 'title',
            dataIndex: 'title',
        },
        {
            title: t('genDict.status'),
            key: 'status',
            dataIndex: 'status',
        },
        {
            title: t('genDict.numberOfCourses'),
            key: 'no_of_courses',
            dataIndex: 'no_of_courses',
        },

        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
        {
            title: t('genDict.action'),
            key: 'action',
            render: (a: any) => {
                return <Space>
                    <Button type="default" shape="circle" icon={<EyeFilled/>}
                            onClick={() => {
                                history.push(`/badges/${a.id}/view`);
                            }}/>
                    <Button type="default" shape="circle" icon={<EditFilled/>}
                            onClick={() => {
                                history.push(`/badges/${a.id}/edit`);
                            }}/>
                    <Button type="primary" danger={true} shape="circle" icon={<DeleteOutlined/>}
                            onClick={() => confirm({
                                icon: <ExclamationCircleOutlined/>,
                                title: t('genDict.confirmDelete'),
                                okText: t('genDict.ok'),
                                cancelText: t('genDict.cancel'),
                                content: `${t('genDict.confirmDelete')} "${a.title}"`,
                                okButtonProps: { loading: deletingItem, danger: true },
                                onOk: async () => {
                                    setDeletingItem(true);
                                    API_SERVICE.removeBadge(a.id).then((d) => {
                                        notification.success({
                                            message: t('genDict.success'),
                                        });
                                        refreshItems();
                                    }).catch((e: any) => {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }).finally(() => {
                                        setDeletingItem(false);
                                    });
                                },
                            })
                            }/>
                </Space>;
            },
        },
    ];
    const refreshItems = async () => {
        try {
            setFetching(true);
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchBadges({ order_by: 'id', page: 1, order: 'DESC' });
            setItems(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#example').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                      //   "emptyTable": "No data available in table"
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":      t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                    
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
        setLang(localStorage.getItem('language'));
    }, []);
    if(fetching){
        return <Skeleton active={true} />
    }
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                    <div className={'list-page-wrapper'}>
                        <div className="container-fluid">
                            <div className={'d-flex justify-space-between mb-3'}>
                                <div className='p-0 d-flex align-items-center'>
                                    <div className={lang == 'ar' ? '' : 'mr-4'}>
                                    <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                    </div>
                                    <div className={lang == 'ar' ? 'ml-2' : ''}><h3 className='mb-0'>{t('genDict.badges')}</h3></div>
                                </div>
                                <div className={lang == 'ar' ? 'mr-2 text-sm-right' : 'text-sm-right'}>
                                    <Button className="btn btn-blue text-capitalize" onClick={() => history.push('badges/create')}>
                                        {/* <span className='d-flex align-items-center'><img src={plusIcon} className="mr-1"/>{t('genDict.add')+' badge'}</span> */}
                                        <span className='d-flex align-items-center'><img src={plusIcon} className={lang == 'ar' ? 'ml-2' : 'mr-2'}/>{t('genDict.AddBages')}</span>
                                    </Button>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 p-0'>
                                    <div className='bg-white p-3 br-5px'>
                                        <div className="row">
                                            {/* <div className='col-lg-12 mb-2'>
                                                <h4 className='float-left'>{t('genDict.badges')}</h4>
                                                <div className='float-right d-flex align-items-center' style={{flexWrap:'nowrap'}}>
                                                    <span className='mr-2' style={{whiteSpace:'nowrap'}}>Search Badge</span>  
                                                    <input type='text' onChange={(e) => searchItems(e.target.value)} placeholder='Enter Badge Title' className='form-control'/>
                                                </div>
                                            </div> */}
                                        <div className="col-md-12 pb-3">
                                            <div className="table-responsive table-br-5 box-shadow mt-2">
                                                <table id="example" className="table  table-meetings table-report">
                                                <thead>
                                                    <tr>
                                                    <th className="text-uppercase text-secondary">{t('genDict.Badge')}</th>
                                                    <th className="text-uppercase text-secondary">{t('genDict.NoOfCourse')}</th>
                                                    <th className="text-uppercase text-secondary text-center">{t('genDict.status')}</th>
                                                    <th className="text-uppercase text-secondary" style={{width:'150px'}}>{t('genDict.AddIn')}</th>
                                                    <th className="text-uppercase text-secondary" style={{width:'100px'}}>{t('genDict.action')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {   
                                                    // searchInput.length > 1 ?
                                                    // filteredResults && filteredResults.map(filtureddata => {
                                                    //     return <tr>
                                                    //     <td>
                                                    //             <div className="d-flex align-items-center">
                                                    //                 <div className="mr-3">
                                                    //                     {/* {item.image.name} */}
                                                    //                     <img src={Parameters.ImageBaseUrl + filtureddata?.image?.slug + filtureddata?.image?.ext} className="uploaded-img-cat" height="40" width="40"/>
                                                    //                 </div>
                                                    //                 <div className="">
                                                    //                     <p className="mb-0"><span>{filtureddata?.title ? filtureddata.title : <></>}</span></p>
                                                    //                 </div>
                                                    //             </div>
                                                    //         </td>
                                                    //         <td className="text-secondary">{filtureddata.no_of_courses}</td>
                                                    //         <td className="text-center">{filtureddata.status === 'ACTIVE'? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                                    //         <td className="text-secondary">{moment(filtureddata.created_at).format('DD MMMM, YYYY')}</td>
                                                    //         <td className="text-secondary">
                                                    //             <div className='d-flex align-items-center'>
                                                    //                 <div className='mr-2'>
                                                    //                     {/* <img src={lockOpen} className="cursor-pointer" style={{width:'15px'}} /> */}
                                                    //                     {
                                                    //                         filtureddata.status === 'INACTIVE' ?
                                                    //                             <Button shape={'circle'} className={'btn-danger'} onClick={() => {
                                                    //                                 API_SERVICE.activateBadge(filtureddata.id).then(() => {
                                                    //                                     refreshItems();
                                                    //                                 }).catch((e) => {
                                                    //                                     notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    //                                 });
                                                    //                             }
                                                    //                             } icon={<LockFilled />} /> :
                                                    //                             <Button shape={'circle'} type={'primary'} onClick={() => {
                                                    //                                 API_SERVICE.deactivateBadge(filtureddata.id).then(() => {
                                                    //                                     refreshItems();
                                                    //                                 }).catch((e) => {
                                                    //                                     notification.error({ message: API_SERVICE.handleErrors(e) });
                                                    //                                 });
                                                    //                             }
                                                    //                             } icon={<UnlockFilled />} />
                                                    //                     }
                                                    //                 </div>
                                                    //                 <div className='mr-3'>
                                                    //                     <img src={viewIcon} className="cursor-pointer" style={{width:'20px'}} onClick={() => {
                                                    //                         history.push(`/badges/${filtureddata.id}/view`);
                                                    //                     }} />
                                                    //                 </div>
                                                    //                 <div className='mr-3'>
                                                    //                     <img src={editIcon} className="cursor-pointer" style={{width:'15px'}} onClick={() => {
                                                    //                         history.push(`/badges/${filtureddata.id}/edit`);
                                                    //                     }} />
                                                    //                 </div>
                                                    //             </div>
                                                    //         </td>
                                                    // </tr>
                                                    // })
                                                    // :
                                                    items && items.map(item => {
                                                        console.log(item);
                                                        
                                                    return <tr>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="mr-3">
                                                                        {/* {item.image.name} */}
                                                                        <img src={Parameters.ImageBaseUrl + item?.image?.slug + item?.image?.ext} className="uploaded-img-cat" height="40" width="40"/>
                                                                    </div>
                                                                    <div className="">
                                                                        <p className="mb-0"><span>{item?.title ? item.title : <></>}</span></p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="text-secondary">{item.no_of_courses}</td>
                                                            <td className="text-center">{item.status === 'ACTIVE'? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                                            <td className="text-secondary">{moment(item.created_at).format('DD MMMM, YYYY')}</td>
                                                            <td className="text-secondary">
                                                                <div className='d-flex align-items-center'>
                                                                    <div className='mr-2'>
                                                                    {
                                                                        item.status === 'INACTIVE' ?
                                                                            <Button shape={'circle'} className='btn-danger' onClick={() => {
                                                                                API_SERVICE.activateBadge(item.id).then(() => {
                                                                                    refreshItems();
                                                                                }).catch((e) => {
                                                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                                });
                                                                            }
                                                                            } icon={<LockFilled />} /> :
                                                                            <Button shape={'circle'} type={'primary'} onClick={() => {
                                                                                API_SERVICE.deactivateBadge(item.id).then(() => {
                                                                                    refreshItems();
                                                                                }).catch((e) => {
                                                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                                });
                                                                            }
                                                                            } icon={<UnlockFilled />} />
                                                                    }
                                                                    </div>
                                                                    <div className='mr-3'>
                                                                        <img src={viewIcon} className="cursor-pointer" style={{width:'20px'}} onClick={() => {
                                                                            history.push(`/badges/${item.id}/view`);
                                                                        }} />
                                                                    </div>
                                                                    <div className='mr-3'>
                                                                        <img src={editIcon} className="cursor-pointer"  style={{width:'15px'}} onClick={() => {
                                                                            history.push(`/badges/${item.id}/edit`);
                                                                        }} />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }) 
                                                }
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <Row gutter={20} justify={'space-between'}>
                            <Col flex={'auto'}>
                                <Title level={3}>{t('genDict.badges')}</Title>
                            </Col>
                            <Col>
                                <Button type={'primary'} onClick={() => history.push('badges/create')}>
                                    {
                                        t('genDict.add')
                                    }
                                </Button>
                            </Col>
                        </Row>
                        <Table loading={fetching} scroll={{ x: true }} pagination={{
                            pageSize: 100,
                            hideOnSinglePage: true,
                        }} dataSource={items} columns={columns}/> */}
                    </div>
                )
            }
        </AuthConsumer>
    );
}
